export default function addRoute(definition = {}) {
    let {
        path = null,
    } = definition;
    const {
        name = null,
        component = null,
        redirect = null,
        alias = null,
        props = null,
        children = null,
        beforeEnter = null,
        meta = null,
        // custom flags
        authorized = true,
        root = null,
    } = definition;
    if (name !== null && path === null) {
        path = `/${name}`;
    }
    if (path === null) {
        throw new Error('All routes must define a path');
    }
    const route = {
        path,
    };

    if (path.indexOf(':') > -1) {
        route.props = true;
    }

    if (name) {
        route.name = name;
    }

    if (component) {
        route.component = component;
    }

    if (redirect) {
        route.redirect = redirect;
    }

    if (alias) {
        route.alias = alias;
    }

    if (props) {
        route.props = props;
    }

    if (children) {
        route.children = children;
    }

    if (beforeEnter) {
        route.beforeEnter = beforeEnter;
    }

    route.meta = {title: name || path, root};

    if (meta) {
        route.meta = {
            ...route.meta,
            ...meta,
        };
    }

    route.meta.authorized = authorized;

    return route;
}
